/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { LoginResponse } from "../models/login-response";
import { ImpersonationRequest } from "../models/impersonation-request";
import { ImpersonationStatus } from "../models/impersonation-status";
@Injectable({
  providedIn: "root",
})
class ImpersonationService extends __BaseService {
  static readonly impersonationStartPath = "/api/Impersonation/Start";
  static readonly impersonationStopPath = "/api/Impersonation/Stop";
  static readonly impersonationStatusPath = "/api/Impersonation/Status";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param model undefined
   */
  impersonationStartResponse(
    model: ImpersonationRequest
  ): __Observable<__StrictHttpResponse<LoginResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Impersonation/Start`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoginResponse>;
      })
    );
  }
  /**
   * @param model undefined
   */
  impersonationStart(model: ImpersonationRequest): __Observable<LoginResponse> {
    return this.impersonationStartResponse(model).pipe(
      __map((_r) => _r.body as LoginResponse)
    );
  }
  impersonationStopResponse(): __Observable<
    __StrictHttpResponse<LoginResponse>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Impersonation/Stop`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoginResponse>;
      })
    );
  }
  impersonationStop(): __Observable<LoginResponse> {
    return this.impersonationStopResponse().pipe(
      __map((_r) => _r.body as LoginResponse)
    );
  }
  impersonationStatusResponse(): __Observable<
    __StrictHttpResponse<ImpersonationStatus>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Impersonation/Status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ImpersonationStatus>;
      })
    );
  }
  impersonationStatus(): __Observable<ImpersonationStatus> {
    return this.impersonationStatusResponse().pipe(
      __map((_r) => _r.body as ImpersonationStatus)
    );
  }
}

module ImpersonationService {}

export { ImpersonationService };
